import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { cn } from '@avanta/shared/utils/cn';
import { useTranslation } from 'react-i18next';

interface WorkplaceConflictInfoProps {
  className?: string;
}

export const WorkplaceConflictInfo = ({
  className,
}: WorkplaceConflictInfoProps): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.SERVICES);

  return (
    <div className={cn('flex flex-col', className)}>
      <p className="text-base am-md:text-lg text-denim-600 text-left px-2 am-sm:px-4 am-md:px-8 whitespace-pre-line">
        {t('SapaCard.Harassment.body')}
      </p>
    </div>
  );
};
